import React from "react";
import { Card } from "react-bootstrap";
import { BsGeoAlt } from "react-icons/bs";
import "./InfoCard.css"

const InfoCard = ({title, value}) => {
  return (
    <Card className="info-card">
      <div className="info-card-text-label">{title}</div>
      <div className="info-card-value mt-1">{value}</div>
      <div className="info-card-icon">
        <BsGeoAlt size={16} />
      </div>
    </Card>
  );
};

export default InfoCard;
